import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConfiguration } from '@klubovna/api-client';
import {
  posTabsControllerAddPayment,
  PosTabsControllerAddPayment$Params,
  posTabsControllerCloseTab,
  PosTabsControllerCloseTab$Params,
  posTabsControllerCreateUserTab,
  PosTabsControllerCreateUserTab$Params,
  posTabsControllerCreateVisitorTab,
  PosTabsControllerCreateVisitorTab$Params,
  posTabsControllerFindOpenTabs,
  PosTabsControllerFindOpenTabs$Params,
  posTabsControllerGetDetail,
  PosTabsControllerGetDetail$Params,
  posTabsControllerPayItemsWithPoints,
  PosTabsControllerPayItemsWithPoints$Params,
  posTabsControllerSearchUsers,
  PosTabsControllerSearchUsers$Params,
  posTabsControllerWriteOffTab,
  PosTabsControllerWriteOffTab$Params,
} from '@klubovna/api-client';
import { OpenTabSummaryDto, PosTab, PosUserDto, TabDetailDto } from '@klubovna/api-client';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PosTabsApiService {
  private http = inject(HttpClient);
  private apiConfig = inject(ApiConfiguration);
  private rootUrl = this.apiConfig.rootUrl;

  findOpenTabs(params?: PosTabsControllerFindOpenTabs$Params): Observable<OpenTabSummaryDto[]> {
    return posTabsControllerFindOpenTabs(this.http, this.rootUrl, params).pipe(
      map((response) => response.body ?? []),
    );
  }

  createUserTab(params: PosTabsControllerCreateUserTab$Params): Observable<PosTab> {
    return posTabsControllerCreateUserTab(this.http, this.rootUrl, params).pipe(
      map((response) => response.body!),
    );
  }

  createVisitorTab(params: PosTabsControllerCreateVisitorTab$Params): Observable<PosTab> {
    return posTabsControllerCreateVisitorTab(this.http, this.rootUrl, params).pipe(
      map((response) => response.body!),
    );
  }

  getDetail(params: PosTabsControllerGetDetail$Params): Observable<TabDetailDto> {
    return posTabsControllerGetDetail(this.http, this.rootUrl, params).pipe(
      map((response) => response.body!),
    );
  }

  closeTab(params: PosTabsControllerCloseTab$Params): Observable<PosTab> {
    return posTabsControllerCloseTab(this.http, this.rootUrl, params).pipe(
      map((response) => response.body!),
    );
  }

  searchUsers(params?: PosTabsControllerSearchUsers$Params): Observable<PosUserDto[]> {
    return posTabsControllerSearchUsers(this.http, this.rootUrl, params).pipe(
      map((response) => response.body ?? []),
    );
  }

  addPayment(params: PosTabsControllerAddPayment$Params): Observable<TabDetailDto> {
    return posTabsControllerAddPayment(this.http, this.rootUrl, params).pipe(
      map((response) => response.body!),
    );
  }

  payItemsWithPoints(params: PosTabsControllerPayItemsWithPoints$Params): Observable<TabDetailDto> {
    return posTabsControllerPayItemsWithPoints(this.http, this.rootUrl, params).pipe(
      map((response) => response.body!),
    );
  }

  writeOffTab(params: PosTabsControllerWriteOffTab$Params): Observable<TabDetailDto> {
    return posTabsControllerWriteOffTab(this.http, this.rootUrl, params).pipe(
      map((response) => response.body!),
    );
  }
}
